module.exports = __webpack_public_path__ + "img/No Orders@2x.a65e614a.png";